import React, { Component } from "react";
import "../App.css";

class ReadListForm extends Component {
  render() {
    return (
      <div className="read-list-wrapper">
        <h1> Sign up for Books! </h1>
        <h2> Join for our weekly readlist </h2>
        <form className="form-wrapper">
          <input
            className="signup-input"
            type="text"
            placeholder="Name"
            name="name"
          ></input>
          <input
            className="signup-input"
            type="text"
            placeholder="Email"
            name="email"
          ></input>
          <button className="submit-button" type="submit">
            Submit
          </button>
        </form>
      </div>
    );
  }
}

export default ReadListForm;
